import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "fm-root" }
const _hoisted_2 = { class: "fm-toolbar" }
const _hoisted_3 = { class: "fm-breadcrumb" }
const _hoisted_4 = { class: "fm-crumb fm-crumb-active" }
const _hoisted_5 = { class: "fm-toolbar-actions" }
const _hoisted_6 = {
  key: 0,
  class: "fm-count"
}
const _hoisted_7 = {
  key: 1,
  class: "fm-count"
}
const _hoisted_8 = {
  key: 0,
  class: "fm-error-inline"
}
const _hoisted_9 = {
  key: 1,
  class: "fm-empty"
}
const _hoisted_10 = {
  key: 2,
  class: "fm-empty"
}
const _hoisted_11 = {
  key: 3,
  class: "fm-empty"
}
const _hoisted_12 = { class: "fm-empty-icon" }
const _hoisted_13 = {
  key: 4,
  class: "fm-grid"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "fm-card-thumb fm-thumb-folder fm-thumb-project" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  width: "38",
  height: "30",
  viewBox: "0 0 38 30",
  fill: "none"
}
const _hoisted_18 = { class: "fm-card-info" }
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "fm-card-meta" }
const _hoisted_21 = { class: "fm-card-type" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "fm-card-info" }
const _hoisted_24 = ["title"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "fm-card-thumb" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "fm-icon-ext" }
const _hoisted_29 = { class: "fm-card-info" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "fm-card-meta" }
const _hoisted_32 = { class: "fm-badge-rev" }
const _hoisted_33 = { class: "fm-card-type" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "fm-viewer-modal" }
const _hoisted_36 = { class: "fm-viewer-header" }
const _hoisted_37 = { class: "fm-viewer-title-group" }
const _hoisted_38 = { class: "fm-icon-ext" }
const _hoisted_39 = { class: "fm-viewer-name" }
const _hoisted_40 = { class: "fm-viewer-meta" }
const _hoisted_41 = { class: "fm-viewer-controls" }
const _hoisted_42 = { class: "fm-viewer-body" }
const _hoisted_43 = ["src"]
const _hoisted_44 = {
  key: 1,
  class: "fm-dwg-placeholder"
}
const _hoisted_45 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["fm-crumb", { 'fm-crumb-active': !_ctx.selectedProjectId }]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitProject && _ctx.exitProject(...args)))
        }, " Arquivos ", 2),
        (_ctx.selectedProject)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fm-crumb-sep" }, "›", -1)),
              _createElementVNode("button", {
                class: _normalizeClass(["fm-crumb", { 'fm-crumb-active': !_ctx.currentFolderId }]),
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exitFolder && _ctx.exitFolder(...args)))
              }, _toDisplayString(_ctx.selectedProject.name), 3)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.currentFolder)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fm-crumb-sep" }, "›", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentFolder.name), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.selectedProjectId)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.projectCards.length) + " projeto" + _toDisplayString(_ctx.projectCards.length !== 1 ? 's' : ''), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.visibleFiles.length) + " arquivo" + _toDisplayString(_ctx.visibleFiles.length !== 1 ? 's' : ''), 1))
      ])
    ]),
    (_ctx.errorText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errorText), 1))
      : (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "fm-empty-icon" }, "⏳", -1),
            _createElementVNode("p", null, "Carregando arquivos...", -1)
          ]))]))
        : (!_ctx.selectedProjectId && _ctx.projectCards.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "fm-empty-icon" }, "📁", -1),
              _createElementVNode("p", null, "Nenhum projeto disponível para visualizar arquivos.", -1)
            ]))]))
          : (_ctx.selectedProjectId && _ctx.gridItems.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentFolderId ? '📂' : '📁'), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.currentFolderId ? 'Esta pasta está vazia.' : 'Nenhum arquivo neste projeto.'), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (!_ctx.selectedProjectId)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.projectCards, (project) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: project.id,
                        class: "fm-card fm-card--folder fm-card--project",
                        onClick: ($event: any) => (_ctx.enterProject(project.id))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          (project.photoDataUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "fm-project-thumb",
                                src: _ctx.$resolveUrl(project.photoDataUrl),
                                alt: ""
                              }, null, 8, _hoisted_16))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[9] || (_cache[9] = [
                                _createElementVNode("rect", {
                                  x: "0",
                                  y: "6",
                                  width: "38",
                                  height: "24",
                                  rx: "3",
                                  fill: "currentColor",
                                  opacity: "0.25"
                                }, null, -1),
                                _createElementVNode("rect", {
                                  x: "0",
                                  y: "3",
                                  width: "16",
                                  height: "6",
                                  rx: "2",
                                  fill: "currentColor",
                                  opacity: "0.4"
                                }, null, -1),
                                _createElementVNode("rect", {
                                  x: "0",
                                  y: "6",
                                  width: "38",
                                  height: "24",
                                  rx: "3",
                                  fill: "currentColor",
                                  opacity: "0.15"
                                }, null, -1)
                              ]))]))
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", {
                            class: "fm-card-name",
                            title: project.name
                          }, _toDisplayString(project.name), 9, _hoisted_19),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(project.filesCount) + " arquivo" + _toDisplayString(project.filesCount !== 1 ? 's' : ''), 1)
                          ])
                        ])
                      ], 8, _hoisted_14))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleFolders, (folder) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'f-' + folder.id,
                          class: "fm-card fm-card--folder",
                          onClick: ($event: any) => (_ctx.enterFolder(folder))
                        }, [
                          _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"fm-card-thumb fm-thumb-folder\" data-v-0a8dfed4><svg width=\"38\" height=\"30\" viewBox=\"0 0 38 30\" fill=\"none\" data-v-0a8dfed4><rect x=\"0\" y=\"6\" width=\"38\" height=\"24\" rx=\"3\" fill=\"currentColor\" opacity=\"0.25\" data-v-0a8dfed4></rect><rect x=\"0\" y=\"3\" width=\"16\" height=\"6\" rx=\"2\" fill=\"currentColor\" opacity=\"0.4\" data-v-0a8dfed4></rect><rect x=\"0\" y=\"6\" width=\"38\" height=\"24\" rx=\"3\" fill=\"currentColor\" opacity=\"0.15\" data-v-0a8dfed4></rect></svg></div>", 1)),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", {
                              class: "fm-card-name",
                              title: folder.name
                            }, _toDisplayString(folder.name), 9, _hoisted_24),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fm-card-meta" }, [
                              _createElementVNode("span", { class: "fm-card-type" }, "Pasta")
                            ], -1))
                          ])
                        ], 8, _hoisted_22))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleFiles, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'file-' + item.id,
                          class: "fm-card fm-card--file",
                          onClick: ($event: any) => (_ctx.openViewer(item))
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            (item.thumbnailBase64)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "fm-thumb-img",
                                  src: item.thumbnailBase64.startsWith('/uploads/') ? _ctx.$resolveUrl(item.thumbnailBase64) : `data:image/jpeg;base64,${item.thumbnailBase64}`,
                                  alt: ""
                                }, null, 8, _hoisted_27))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass(["fm-file-icon", `fm-icon-${item.extension.toLowerCase()}`])
                                }, [
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(item.extension.toUpperCase()), 1)
                                ], 2))
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", {
                              class: "fm-card-name",
                              title: item.name
                            }, _toDisplayString(item.name), 9, _hoisted_30),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("span", _hoisted_32, _toDisplayString(item.revision || 'R0'), 1),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(item.extension.toUpperCase()), 1)
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "fm-card-hover",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("button", {
                              class: "fm-action-btn",
                              title: "Visualizar",
                              onClick: ($event: any) => (_ctx.openViewer(item))
                            }, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 16 16",
                                fill: "none"
                              }, [
                                _createElementVNode("path", {
                                  d: "M8 3C4.5 3 1.5 8 1.5 8s3 5 6.5 5 6.5-5 6.5-5-3-5-6.5-5zm0 8a3 3 0 110-6 3 3 0 010 6z",
                                  fill: "currentColor"
                                }),
                                _createElementVNode("circle", {
                                  cx: "8",
                                  cy: "8",
                                  r: "1.5",
                                  fill: "currentColor"
                                })
                              ], -1)
                            ]))], 8, _hoisted_34)
                          ])
                        ], 8, _hoisted_25))
                      }), 128))
                    ], 64))
              ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "viewer-fade" }, {
        default: _withCtx(() => [
          (_ctx.viewerFile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fm-viewer-overlay",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeViewer && _ctx.closeViewer(...args)), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["fm-file-icon fm-file-icon-sm", `fm-icon-${_ctx.viewerFile.extension.toLowerCase()}`])
                      }, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.viewerFile.extension.toUpperCase()), 1)
                      ], 2),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.viewerFile.name), 1),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.viewerFile.extension.toUpperCase()) + " · " + _toDisplayString(_ctx.viewerFile.revision || 'R0') + _toDisplayString(_ctx.viewerFile.description ? ' · ' + _ctx.viewerFile.description : ''), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("button", {
                        class: "fm-viewer-close",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeViewer && _ctx.closeViewer(...args)))
                      }, "✕")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    (_ctx.viewerFile.extension === 'pdf')
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 0,
                          class: "fm-iframe",
                          src: _ctx.viewerFile.url ? _ctx.$resolveUrl(_ctx.viewerFile.url) : `data:${_ctx.viewerFile.mimeType};base64,${_ctx.viewerFile.contentBase64}`
                        }, null, 8, _hoisted_43))
                      : (_ctx.viewerFile.extension === 'dwg')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("div", { class: "fm-dwg-big" }, "📐", -1),
                            _createElementVNode("p", null, "Arquivo DWG", -1),
                            _createElementVNode("p", { class: "fm-viewer-meta" }, "Visualização DWG não disponível no navegador.", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            class: "fm-img-viewer",
                            src: _ctx.viewerFile.url ? _ctx.$resolveUrl(_ctx.viewerFile.url) : `data:${_ctx.viewerFile.mimeType};base64,${_ctx.viewerFile.contentBase64}`,
                            alt: "preview"
                          }, null, 8, _hoisted_45))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}